import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Observable, Observer, Subject } from "rxjs-compat";


@Injectable()
export class WebsocketService {
  constructor(protected _snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,) { }

  private subject: Subject<MessageEvent>;

  public connect(url): Subject<MessageEvent> {
    if (!this.subject) this.subject = this.create(url);

    return this.subject;
  }

  private create(url): Subject<MessageEvent> {
    let ws = new WebSocket(url);
    let observable = Observable.create((obs: Observer<MessageEvent>) => {
      ws.onmessage = obs.next.bind(obs);
      ws.onerror = obs.error.bind(obs);
      ws.onclose = obs.complete.bind(obs);
      return ws.close.bind(ws);
    });
    let observer = {
      next: (data: Object) => {
        if (ws.readyState === WebSocket.OPEN) {
          this.spinner.start();
          ws.send(JSON.stringify(data));
        }
      }
    };
    return Subject.create(observer, observable);
  }
}
